import { Sparkles, Play, Calendar, MessageCircle, TrendingUp, Zap } from "lucide-react";
import { useTheme } from '@/contexts/ThemeContext';
import { c } from '@/config/region';
import AnimatedBorderBadge from './AnimatedBorderBadge';

const EditorialPlatformSection = () => {
  const { theme } = useTheme();
  
  const headingColor = theme === 'dark' ? '#FFFFFF' : '#111111';
  const textColor = theme === 'dark' ? '#AAAAAA' : '#555555';
  const borderColor = theme === 'dark' ? '#333333' : '#E0E0E0';
  const cardBgColor = theme === 'dark' ? '#222222' : '#F8F8F8';
  const featureBadgeBgColor = theme === 'dark' ? '#1A1A1A' : '#f4f2f1';

  const badges = [
    { icon: Play, label: "Create" },
    { icon: Calendar, label: "Schedule" },
    { icon: MessageCircle, label: "Engage" },
    { icon: TrendingUp, label: "Analyze" },
    { icon: Zap, label: "Automate" },
  ];

  return (
    <section 
      className="w-full py-16 px-[7%] sm:px-6 transition-colors duration-300"
      style={{ backgroundColor: theme === 'dark' ? '#111111' : '#FFFFFF' }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="lg:flex-1">
            <AnimatedBorderBadge text="Growth" icon={Sparkles} align="left" />

            <h2 className="text-3xl lg:text-4xl font-bold mb-4 tracking-tight" style={{ color: headingColor }}>
              The Shortest Path from Lead to{' '}<br className="hidden sm:block" />Loyal Client.
            </h2>
            <p className="text-sm mb-6 max-w-2xl" style={{ color: textColor }}>
              Automatically capture and nurture every prospect until they are part of your practice.
            </p>
            <div className="flex flex-wrap gap-2">
              {badges.map((badge) => (
                <div key={badge.label} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full transition-all duration-200 hover:scale-105 hover:shadow-lg cursor-pointer" style={{ backgroundColor: featureBadgeBgColor, border: `1px solid ${borderColor}` }}>
                  <badge.icon className="w-3 h-3" style={{ color: textColor }} />
                  <span className="text-xs font-medium" style={{ color: headingColor }}>{badge.label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-row gap-3">
            {[{ value: c('$29k+'), label: 'annual stack saving' }, { value: '24/7', label: 'response time' }, { value: '0%', label: 'leads missed again' }].map((stat, i) => (
              <div key={i} className="rounded-xl p-4 w-32 transition-all duration-200 hover:scale-105 cursor-pointer" style={{ backgroundColor: cardBgColor, border: `1px solid ${borderColor}`, boxShadow: '0 15px 30px -8px rgba(0, 0, 0, 0.12)' }}>
                <div className="text-xl lg:text-2xl font-bold mb-0.5" style={{ color: headingColor }}>{stat.value}</div>
                <div className="text-xs" style={{ color: textColor }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorialPlatformSection;
